import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Relationship, RelationshipService } from '../../modules/relationship';
import { DisplayService } from '@qid/core';
import { CommonModule } from '@angular/common';
import { IonHeader, IonToolbar, IonButtons, IonBackButton, IonTitle, IonContent } from '@ionic/angular/standalone';
import { SexyModule } from '@qid/sexy';
import { AvatarRoundComponent } from '@qid/super';

@Component({
    selector: 'app-view-customer',
    templateUrl: './view-customer.page.html',
    styleUrls: ['./view-customer.page.scss'],
    standalone: true,
    imports: [
        CommonModule,
        SexyModule,
        AvatarRoundComponent,
        IonHeader,
        IonToolbar,
        IonButtons,
        IonBackButton,
        IonTitle,
        IonContent
    ],
})
export class ViewCustomerPage implements OnInit {
    customerId: string;
    customer: Relationship;

    constructor(
        private route: ActivatedRoute,
        private relationshipService: RelationshipService,
        private displayService: DisplayService
    ) {
        this.customerId = this.route.snapshot.paramMap.get('id') || '';
    }

    async ngOnInit() {
        await this.loadCustomer();
    }

    async loadCustomer() {
        try {
            const response = await this.relationshipService.readCustomerById(this.customerId);
            if (response && response.data) {
                this.customer = response.data;
            }
        } catch (error) {
            await this.displayService.toast({
                message: 'Failed to load customer details',
                color: 'danger'
            });
        }
    }
} 